import React from 'react';
import { BookOpenIcon, CalendarIcon, ClockIcon, CreditCardIcon, FileTextIcon, GiftIcon, LockIcon, PrinterIcon, ShieldCheckIcon, StarIcon, UsersIcon } from 'lucide-react';
import { Button } from './ui/Button';
const mockupUrl = 'https://cdn.magicpatterns.com/uploads/1MGzgnUyww8NC7r31qr9DW/ChatGPT_Image_11_jul_2026,_09_10_29_a.m..png';
export function Hero() {
  return <section className="relative overflow-hidden px-4 pb-14 pt-9 md:pb-20 md:pt-16" data-id="element-220">
      <div className="pointer-events-none absolute left-1/2 top-[18%] h-[540px] w-[540px] -translate-x-1/2 rounded-full bg-teal/10 blur-[110px]" data-id="element-221" />
      <div className="relative mx-auto max-w-5xl text-center" data-id="element-222">
        <div className="mb-5 inline-flex rounded-full border border-teal/20 bg-teal/10 px-4 py-1.5 font-display text-[11px] font-bold uppercase tracking-wider text-primary md:mb-7" data-id="element-223">
          🎒 Compra Digital Ya™
        </div>

        <h1 className="mx-auto max-w-4xl text-[1.75rem] font-extrabold leading-[1.1] tracking-tight text-slate-900 md:text-6xl" data-id="element-224">
          Tus clases de stretching,{' '}
          <span className="text-teal" data-id="element-225">listas desde hoy.</span>
        </h1>

        <p className="mx-auto mt-4 max-w-3xl text-base font-medium leading-relaxed text-slate-600 md:mt-6 md:text-xl" data-id="element-226">
          Combo Completo Stretching 2026. El sistema N°1 para profesores/as,
          instructores y entrenadores que dan clases de stretching en Argentina.
        </p>

        <a href="#pricing" className="group my-5 flex justify-center rounded-3xl focus:outline-none md:my-7" aria-label="Ir a la sección de compra del Combo Completo Stretching" data-id="element-227">
          <img className="w-[90%] max-w-[660px] object-contain drop-shadow-[0_24px_38px_rgba(7,59,92,.20)] transition-transform duration-300 group-hover:scale-[1.015]" src={mockupUrl} alt="Mockup del Combo Completo Stretching Pro con tomos, recursos y planificador de rutinas" data-id="element-228" />
        </a>

        <p className="font-bold text-slate-900 md:text-lg" data-id="element-229">
          Combo Completo Stretching 2026 — 5 Tomos + 5 Bonos + Stretching
          adultos mayores
        </p>

        <div className="mt-6 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs font-medium text-slate-600 md:text-sm" data-id="element-230">
          <span className="flex items-center gap-1.5" data-id="element-231">
            <FileTextIcon className="h-4 w-4 text-teal" data-id="element-232" />
            100% PDF
          </span>
          <span className="flex items-center gap-1.5" data-id="element-233">
            <ClockIcon className="h-4 w-4 text-teal" data-id="element-234" />
            Acceso en 5 min
          </span>
          <span className="flex items-center gap-1.5" data-id="element-235">
            <CalendarIcon className="h-4 w-4 text-teal" data-id="element-236" />
            Stretching 2026
          </span>
          <span className="flex items-center gap-1.5" data-id="element-237">
            <PrinterIcon className="h-4 w-4 text-teal" data-id="element-238" />
            Listo para usar en clase
          </span>
        </div>

        <div className="mt-7" data-id="element-239">
          <Button href="#pricing" className="w-full text-sm md:w-auto md:px-10 md:py-5 md:text-lg" data-id="element-240">
            QUIERO EL SISTEMA COMBO COMPLETO STRETCHING
          </Button>
        </div>

        <div className="mt-4 flex flex-wrap justify-center gap-x-4 gap-y-1 text-[11px] font-medium text-slate-500 md:text-sm" data-id="element-241">
          <span className="flex items-center gap-1" data-id="element-242">
            <ShieldCheckIcon className="h-3.5 w-3.5 text-teal" data-id="element-243" />
            Garantía 7 días
          </span>
          <span className="text-slate-300" data-id="element-244">·</span>
          <span className="flex items-center gap-1" data-id="element-245">
            <LockIcon className="h-3.5 w-3.5 text-teal" data-id="element-246" />
            Pago seguro
          </span>
          <span className="text-slate-300" data-id="element-247">·</span>
          <span className="flex items-center gap-1" data-id="element-248">
            <CreditCardIcon className="h-3.5 w-3.5 text-teal" data-id="element-249" />
            Mercado Pago
          </span>
        </div>

        <div className="mt-10 grid grid-cols-2 gap-3 md:mt-14 md:grid-cols-4" data-id="element-250">
          <div className="flex flex-col items-center gap-2 rounded-2xl border border-sky-100 bg-white p-3 shadow-sm" data-id="element-251">
            <UsersIcon className="h-5 w-5 text-teal" data-id="element-252" />
            <span className="text-center text-[11px] font-bold leading-tight text-slate-800 md:text-sm" data-id="element-253">
              +500 profesionales ya usan el sistema
            </span>
          </div>
          <div className="flex flex-col items-center gap-2 rounded-2xl border border-sky-100 bg-white p-3 shadow-sm" data-id="element-254">
            <BookOpenIcon className="h-5 w-5 text-teal" data-id="element-255" />
            <span className="text-center text-[11px] font-bold leading-tight text-slate-800 md:text-sm" data-id="element-256">
              5 Tomos listos para usar
            </span>
          </div>
          <div className="flex flex-col items-center gap-2 rounded-2xl border border-sky-100 bg-white p-3 shadow-sm" data-id="element-257">
            <GiftIcon className="h-5 w-5 text-teal" data-id="element-258" />
            <span className="text-center text-[11px] font-bold leading-tight text-slate-800 md:text-sm" data-id="element-259">
              5 Bonos incluidos gratis
            </span>
          </div>
          <div className="flex flex-col items-center gap-2 rounded-2xl border border-sky-100 bg-white p-3 shadow-sm" data-id="element-260">
            <StarIcon className="h-5 w-5 fill-gold text-gold" data-id="element-261" />
            <span className="text-center text-[11px] font-bold leading-tight text-slate-800 md:text-sm" data-id="element-262">
              4.9/5 · Cinco estrellas
            </span>
          </div>
        </div>
      </div>
    </section>;
}